
export default function CaseStudies() {
  const caseStudies = [
    {
      company: 'Industrial Equipment Distributor',
      industry: 'Manufacturing',
      challenge: 'High landed costs and inconsistent supplier quality',
      result: '32% reduction in landed costs and improved delivery times by 40%',
      quote: 'Inter-American Procurement Group transformed our Latin America sourcing strategy. Their expertise in supplier negotiation and freight optimization delivered results beyond our expectations.',
      author: 'Michael Chen',
      position: 'VP of Operations',
      logo: 'ri-building-4-line'
    },
    {
      company: 'Medical Device Importer',
      industry: 'Healthcare',
      challenge: 'Complex compliance requirements and limited supplier options',
      result: 'Identified 12 qualified suppliers and reduced procurement cycle time by 50%',
      quote: 'Their deep understanding of medical product sourcing and regulatory compliance made them an invaluable partner. We now have a reliable supply chain we can count on.',
      author: 'Sarah Martinez',
      position: 'Director of Supply Chain',
      logo: 'ri-heart-pulse-line'
    },
    {
      company: 'Construction Materials Supplier',
      industry: 'Construction',
      challenge: 'Volatile pricing and unreliable delivery schedules',
      result: '28% cost savings and 95% on-time delivery rate achieved',
      quote: 'The team\'s ability to negotiate favorable terms and optimize our freight strategy has been game-changing. Our margins have improved significantly while maintaining quality.',
      author: 'Robert Thompson',
      position: 'Procurement Manager',
      logo: 'ri-building-line'
    },
    {
      company: 'Specialty Chemical Distributor',
      industry: 'Industrial',
      challenge: 'Limited market knowledge and high transaction costs',
      result: 'Expanded supplier base by 200% and reduced administrative overhead by 45%',
      quote: 'Working with Inter-American Procurement Group gave us access to suppliers we never knew existed. Their market intelligence and procurement support have been exceptional.',
      author: 'Jennifer Lee',
      position: 'Chief Operating Officer',
      logo: 'ri-flask-line'
    }
  ];

  return (
    <section id="case-studies" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-orange-100 text-orange-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Case Studies
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Proven Results for Growing Companies
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Real success stories from clients who transformed their procurement operations
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {caseStudies.map((study, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start mb-6">
                <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                  <i className={`${study.logo} text-2xl text-orange-600`}></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-1">
                    {study.company}
                  </h3>
                  <p className="text-sm text-orange-600 font-medium">
                    {study.industry}
                  </p>
                </div>
              </div>

              <div className="mb-6">
                <div className="mb-4">
                  <h4 className="text-sm font-semibold text-gray-900 mb-2">Challenge:</h4>
                  <p className="text-gray-600">{study.challenge}</p>
                </div>
                <div className="bg-orange-50 p-4 rounded-lg">
                  <h4 className="text-sm font-semibold text-gray-900 mb-2">Result:</h4>
                  <p className="text-orange-700 font-medium">{study.result}</p>
                </div>
              </div>

              <blockquote className="border-l-4 border-orange-600 pl-4 mb-6">
                <p className="text-gray-700 italic mb-4">"{study.quote}"</p>
                <footer className="text-sm">
                  <strong className="text-gray-900">{study.author}</strong>
                  <span className="text-gray-600"> — {study.position}</span>
                </footer>
              </blockquote>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
